export const MockConfigData = { heading: "Log In" };
